import * as React from 'react';
import { Icon, getIcon } from '../../lib/icons';
import * as MuiCore from '@mui/material';
import * as PXBColors from '@brightlayer-ui/colors';

export const AppBanner: React.FC<{
    icon: Icon;
    message: string;
    buttons: Array<{
        label: string;
        disabled?: boolean;
        onClick: ((event: React.MouseEvent<HTMLButtonElement>) => void) | undefined;
    }>;
}> = (props) => {
    const TheIcon = getIcon(props.icon);

    return (
        <MuiCore.Paper square>
            <MuiCore.Box display="flex" style={{ alignItems: 'center', justifyContent: 'flex-start', height: '72px' }}>
                <MuiCore.Avatar style={{ backgroundColor: PXBColors.blue[500], marginLeft: '54px' }}>
                    <TheIcon style={{ color: PXBColors.white[500] }} />
                </MuiCore.Avatar>
                <div style={{ flex: '1', marginLeft: '16px', marginRight: '16px' }}>
                    <MuiCore.Typography variant="body2">{props.message}</MuiCore.Typography>
                </div>
                <div style={{ marginRight: '16px' }}>
                    {props.buttons.map((button, index) => (
                        <MuiCore.Button
                            style={{ marginLeft: '5px' }}
                            color="secondary"
                            variant="outlined"
                            key={index}
                            disabled={button.disabled}
                            onClick={button.onClick}
                        >
                            {button.label}
                        </MuiCore.Button>
                    ))}
                </div>
            </MuiCore.Box>
        </MuiCore.Paper>
    );
};
